module.exports = __webpack_public_path__ + "img/scoring_scale.ac063cbc.png";